import React, { FC, Fragment, useState, useEffect } from 'react';
import { Box, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useMatch } from 'react-router-dom';
import { LabClient } from 'models/client-directory';
import SupplierContactDetails from './supplier-contact-details/supplier-contact-details.component';

type SupplierDetailsProps = {
    labClient: LabClient;
};

const SupplierDetails: FC<SupplierDetailsProps> = ({ labClient }: SupplierDetailsProps) => {
    const { t: translate } = useTranslation(['client-directory']);
    const navigate = useNavigate();
    const location = useLocation();
    const [tabState, setTabState] = useState('#contactDetails');
    const match = useMatch('/supplier-directory/:id/:tab');

    useEffect(() => {
        setTabState(location.hash);
    }, [location]);

    const handleTabChange = (_: unknown, newTabState: string) => {
        if (tabState !== newTabState) {
            navigate(`${match?.pathnameBase}${newTabState}`);
            setTabState(newTabState);
        }
    };

    return (
        <Fragment>
            <Typography mb={1} variant="h2">
                {translate('client-directory:SUPPLIER_DETAILS')}
            </Typography>
            <TabContext value={tabState}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                        <Tab label={translate('client-directory:SUPPLIER_CONTACT_DETAILS')} value="#contactDetails" />
                    </TabList>
                </Box>
                <Box sx={{ maxWidth: 900 }}>
                    <TabPanel sx={{ padding: 0 }} value="#contactDetails">
                        <SupplierContactDetails labClient={labClient} />
                    </TabPanel>
                </Box>
            </TabContext>
        </Fragment>
    );
};

export default SupplierDetails;
